module.exports = __webpack_public_path__ + "img/support-staff.4b03dd95.png";